import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/CategoryMerchantsTable/GET';

export const CATEGORY_MERCHANTS_TABLE_GET_SUCCESS = `${rootActionPath}_${SUCCESS_SUFFIX}`;
export const CATEGORY_MERCHANTS_TABLE_GET_FAILURE = `${rootActionPath}_${FAILURE_SUFFIX}`;
